import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { IntegrationsListComponent } from './integrations-list/integrations-list.component'
import { MatButtonModule } from '@angular/material/button'
import { MatIcon } from '@angular/material/icon'
import { Dialog } from '@angular/cdk/dialog'
import { DialogService } from '../../../services/dialog.service'
import { ErrorService } from '../../../services/error.service'
import { IntegrationService } from '../../../services/integration.service'
import { SpinnerService } from '../../../services/spinner.service'
import { ApiError } from '../../../types/apiError'
import { Subject, firstValueFrom } from 'rxjs'
import { Clipboard } from '@angular/cdk/clipboard'
import { RouteService } from '../../../services/route.service'
import { ROUTES } from '../../../constants/routes'
import { TranslationService } from '../../../services/translation.service'

@Component({
  selector: 'app-integrations',
  imports: [IntegrationsListComponent, MatButtonModule, MatIcon],
  templateUrl: './integrations.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './integrations.component.scss',
})
export class IntegrationsComponent {
  dialog = inject(Dialog)
  clipboard = inject(Clipboard)
  dialogService = inject(DialogService)
  errorService = inject(ErrorService)
  spinnerService = inject(SpinnerService)
  integrationService = inject(IntegrationService)
  routeService = inject(RouteService)
  translationService = inject(TranslationService)

  refreshListSubject: Subject<boolean> = new Subject<boolean>()

  constructor() {
    const currentRoute = this.routeService.getUserRoutes(
      ROUTES.INTEGRATIONS.title,
      `/admin/${ROUTES.INTEGRATIONS.path}`,
    )
    this.routeService.setRoute(currentRoute)
  }

  /**
   * Creates an Integration Session and refreshes the Integration Session List upon completion
   */
  async create() {
    try {
      this.spinnerService.startSpinner()
      const apiKey = await firstValueFrom(this.integrationService.create())
      this.clipboard.copy(apiKey)
      this.dialogService.showDialog(
        this.dialog,
        this.translationService.getIntegrationsText(),
        this.translationService.getIntegrationKeyCreatedMsg(),
      )
      this.spinnerService.stopSpinner()

      this.refreshListSubject.next(true)
    } catch (err) {
      this.spinnerService.stopSpinner()
      const apiErr = err as ApiError
      this.errorService.handleErr(this.dialogService, apiErr, this.dialog)
    }
  }
}
